import {AxiosResponse} from 'axios'
import {
  GenericMessageResponse,
  GetSiemHttpIntegrationResponse,
  GetSiemS3IntegrationResponse,
  PostSiemHttpIntegrationRequest,
  PostSiemHttpIntegrationResponse,
  PostSiemS3IntegrationAction,
} from 'interfaces'
import {unwrapAPIError} from 'utils'
import {getSIEMBaseUrl, requestHandler} from '../HTTP'
import {EndPoints, HttpMethods} from '../HTTP/HTTP.types'

const siemBaseUrl = getSIEMBaseUrl()

const getSiemHttpIntegration = async (): Promise<
  AxiosResponse<GetSiemHttpIntegrationResponse>
> => {
  try {
    return await requestHandler<GetSiemHttpIntegrationResponse>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${siemBaseUrl}${EndPoints.SiemHttp}`,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const postSiemHttpIntegration = async (
  payload: PostSiemHttpIntegrationRequest,
): Promise<AxiosResponse<PostSiemHttpIntegrationResponse>> => {
  try {
    return await requestHandler<PostSiemHttpIntegrationResponse>({
      method: HttpMethods.POST,
      // Override axios baseUrl
      url: `${siemBaseUrl}${EndPoints.SiemHttp}`,
      data: {...payload},
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const deleteSiemHttpIntegration = async (): Promise<
  AxiosResponse<GenericMessageResponse>
> => {
  try {
    return await requestHandler<GenericMessageResponse>({
      method: HttpMethods.DELETE,
      // Override axios baseUrl
      url: `${siemBaseUrl}${EndPoints.SiemHttp}`,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const getSiemS3Integration = async (): Promise<
  AxiosResponse<GetSiemS3IntegrationResponse>
> => {
  try {
    return await requestHandler<GetSiemS3IntegrationResponse>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${siemBaseUrl}${EndPoints.SiemS3}`,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const postSiemS3Integration = async ({
  bucketName,
  actionType,
}: PostSiemS3IntegrationAction): Promise<
  AxiosResponse<GenericMessageResponse>
> => {
  try {
    const params = {action: actionType}
    return await requestHandler<GenericMessageResponse>({
      method: HttpMethods.POST,
      // Override axios baseUrl
      url: `${siemBaseUrl}${EndPoints.SiemS3}`,
      data: {
        bucketName,
      },
      options: {
        params,
      },
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const deleteSiemS3Integration = async (): Promise<
  AxiosResponse<GenericMessageResponse>
> => {
  try {
    return await requestHandler<GenericMessageResponse>({
      method: HttpMethods.DELETE,
      // Override axios baseUrl
      url: `${siemBaseUrl}${EndPoints.SiemS3}`,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const SIEMService = {
  getSiemHttpIntegration,
  postSiemHttpIntegration,
  deleteSiemHttpIntegration,
  getSiemS3Integration,
  postSiemS3Integration,
  deleteSiemS3Integration,
}
